export default __webpack_public_path__ + "static/media/regulatory--pedestrians-keep-left--g1.674c2d80.png";